module.exports = __webpack_public_path__ + "static/media/10.5ec7efa6.jpg";